import React, { useEffect, useRef, useState } from "react";
import { PaymentCustomerInformationType } from "../../../../common/types";
import { turkishtoEnglish } from "../../../../common/helpers/globalHelpers";
import CircleLoader from "../CircleLoader";




type Props = {
    show: boolean;
    hide: () => void;
    onSelect: (value: PaymentCustomerInformationType) => void;
    customerList: Array<PaymentCustomerInformationType>,
    selectedCustomer?: number,
    searchValue?: string,
    isLoading: boolean
}
const pageLength = 20;

const CustomerSelectBox = React.memo((props: Props) => {

    const isPageChangeRef = useRef(false);

    const { customerList, onSelect, show, searchValue } = props;
    const [page, setPage] = useState(1);

    useEffect(() => {

    }, [page]);


    useEffect(() => {
        const contentDiv: any = document.getElementById("select-content");

        const handleScroll = () => {
            // Div'in altına kaydığında tetiklenecek fonksiyon
            const { scrollHeight, scrollTop, clientHeight } = contentDiv;

            const offset = scrollHeight - scrollTop;
            if (isPageComplete()) {
                return;
            }
            if ((offset - 50) <= clientHeight) {

                if (true) {
                    isPageChangeRef.current = true;
                    const newPage = page + 1;
                    setPage(newPage);
                }
            }
        };

        contentDiv.addEventListener("scroll", handleScroll);

        return () => {
            contentDiv.removeEventListener("scroll", handleScroll);
        };
    }, [page, customerList]);


    const getCustomersWithoutPaging = () => {

        let resultList = customerList;
        if (searchValue && searchValue.length > 0) {
            resultList = customerList.filter((customer) => {
                return turkishtoEnglish(customer.customerName || "")
                    .toLowerCase()
                    .includes(turkishtoEnglish(searchValue).toLowerCase()) ||
                    turkishtoEnglish(customer.customerCode || "")
                        .toLowerCase()
                        .includes(turkishtoEnglish(searchValue).toLowerCase()) ||
                    turkishtoEnglish(customer.taxCode || "")
                        .toLowerCase()
                        .includes(turkishtoEnglish(searchValue).toLowerCase());
            })
        };

        return resultList;
    }

    const getCustomerList = () => {

        let resultList = getCustomersWithoutPaging();


        resultList = resultList.slice(0, (pageLength * page));

        return resultList;
    }

    const isPageComplete = () => {

        const pagingLength = pageLength * page;
        const listLength = getCustomersWithoutPaging().length;

        if (listLength <= pagingLength) {
            return true;
        }
        return false;
    }




    const getEmptyListView = () => {

        if (props.isLoading) {
            return (
                <div className="items-center justify-center flex mt-5 text-lg mb-5">
                    <CircleLoader />
                    
                </div>
            );
        }
        return (
            <div className="items-center justify-center flex mt-5 text-lg mb-5">
                Herhangi bir kayıt bulunamadı.
            </div>
        );
    }


    const data = getCustomerList();


    return !show ? <div hidden id="select-content"></div> : (
        <div id="select-content" className={`custom-dropdownmodal border border-t-0 border-light-border shadow-lg rounded-b-2xl px-4`}>

            {data.length == 0 ? getEmptyListView() : data?.map((item, index) => {

                return (
                    <div
                        className={`flex flex-col justify-between px-2 mb-2 py-2 cursor-pointer  border-gray-200 border-b-2  bg-light-gray-2 
                         border-transparent border-2 hover:border-blue-700 rounded-md  
                                     ${props.selectedCustomer == item.customerId && "!border-blue-700 !border-2"} 
                                     `}
                        key={index + "customerList"}
                        onClick={() => onSelect(item)}
                    >
                        <div className="  text-dark text-sm font-bold mb-1.5 line-clamp-2 min-h-[30px]">
                            {item.customerName}
                        </div>
                        <div className="flex items-center justify-between">
                            <div className="">
                                <div className="text-2xs text-silver-gray">
                                    VKN / TCKN
                                </div>
                                <div className="text-base font-normal text-dark-10">
                                    {item.taxCode}
                                </div>
                            </div>
                            <div className="">
                                <div className="text-2xs text-silver-gray">
                                    Cari Kod
                                </div>
                                <div className="text-base font-normal text-dark-10">
                                    {item.customerCode}
                                </div>
                            </div>
                        </div>

                    </div>
                );
            })}


        </div>
    );
})
export default CustomerSelectBox